import { EventTypeEnum, EventStreamingTypeEnum } from "@prisma/client";
import dayjs from "dayjs";
import { useState } from "react";
import { EventContentData } from "../useEvents/types";
const getInitialFormValues = (content?: EventContentData) => {
  const now = dayjs();
  const initialDate = content?.event?.startTime
    ? dayjs(content?.event.startTime * 1000).format("YYYY-MM-DD")
    : now.locale("de").format("YYYY-MM-DD");
  const initialStart = content?.event?.startTime
    ? dayjs(content?.event.startTime * 1000).format("HH:mm")
    : now.add(1, "hour").format("HH:mm");
  const duration =
    content?.event?.endTime && content?.event?.startTime
      ? (content?.event?.endTime - content?.event?.startTime) / 60
      : 60;
  const initialValues = content?.event
    ? {
        ...content,
        date: initialDate,
        duration: duration,
        startTime: initialStart,
        title: content.title ?? "",
        description: content.description ?? "",
        instructor: content.event.instructor,
        streamingUrl: content?.event?.streamingUrl ?? "",
        maxOnlineParticipants: content.event.maxParticipants ?? 0,
        maxOfflineParticipants: content.event.maxParticipants ?? 0,
        location: content.event.location || "Im Studio",
      }
    : {
        streamingUrl: "",
        date: initialDate,
        duration: duration,
        startTime: initialStart,
      };
  return initialValues;
};

const getInitialState = (
  mode?: "create" | "edit",
  content?: EventContentData,
  spaceId?: string
) => {
  let initialData;
  if (content?.event) {
    initialData = {
      hasLimitedOfflineParticipants: !!(
        content?.event?.maxParticipants && content?.event.maxParticipants > 0
      ),
      hasLimitedOnlineParticipants: !!(
        content?.event?.maxParticipants && content?.event.maxParticipants > 0
      ),
      hasOnlineWaitlist: !!content?.event?.waitlistId,
      hasOfflineWaitlist: !!content?.event?.waitlistId,
      type:
        content?.event?.type === "online" || mode === "create"
          ? "online"
          : "offline",
      isCancelable:
        content.event.isCancelable != undefined
          ? content.event.isCancelable
          : true,
      isRecurring:
        content.event.isRecurring != undefined
          ? content.event.isRecurring
          : false,
      color: content?.color ?? undefined,
      price: content.price ?? 0,
      credits: content.credits ?? 0,
      taxRates: content.taxRates?.map((el) => el.id) ?? [],
      spaceId: content?.spaceId || "",
      linkedProducts: content?.linkedProducts?.map((el) => el.id) || [],
      streamingType: content?.event.streamingType as EventStreamingTypeEnum,
      recurrenceSettings: {},
    };
  } else {
    initialData = {
      hasLimitedOfflineParticipants: false,
      hasLimitedOnlineParticipants: false,
      hasOnlineWaitlist: false,
      hasOfflineWaitlist: false,
      type: "online",
      isCancelable: true,
      color: undefined,
      price: 0,
      credits: 0,
      spaceId: spaceId ?? "",
      taxRates: [] as string[],
      linkedProducts: [] as string[],
      isRecurring: false,
      recurrenceSettings: {},
      streamingType: "custom" as EventStreamingTypeEnum,
    };
  }
  return initialData;
};

const useEventFormValues = (defaultValues?: EventContentData) => {
  return getInitialFormValues(defaultValues);
};
const useEventFormState = (
  mode: "create" | "edit",
  defaultValues?: EventContentData,
  spaceId?: string
) => {
  return useState(getInitialState(mode, defaultValues, spaceId));
};

export { useEventFormState, useEventFormValues };
